// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs, doc, updateDoc, addDoc } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDXz6Zgo1w5CiL7nC77FDXv-CaxeVrgf4M",
    authDomain: "portfolio-v2-react-mek.firebaseapp.com",
    projectId: "portfolio-v2-react-mek",
    storageBucket: "portfolio-v2-react-mek.firebasestorage.app",
    messagingSenderId: "841222726109",
    appId: "1:841222726109:web:7559e000a331ba87c21634"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };